(function($){
    var threshold = 200; // px
    var throttle = 250; // ms
    var body = $('body');
    $(window).scroll(_.throttle(function(){
        if ($(window).scrollTop() >= threshold) {
            body.addClass('site-announcement--scroll');
        } else if (body.hasClass('site-announcement--scroll')) {
            body.removeClass('site-announcement--scroll');
        }
    }, throttle)).trigger('scroll');
    // dismiss link
    $('.site-announcement__dismiss-link').on('click', function(e){
        e.preventDefault();
        var announcement = $(this).closest('.site-announcement');
        var id = announcement.data('id');
        announcement.addClass('dismissed');
        document.cookie = "site-announcement=1; path=/";
        if (announcement.hasClass('.site-announcement--primary')) {
            body.removeClass('site-announcement--active');
        }
    });
    // show primary
    if ($('.site-announcement--primary').length) body.addClass('site-announcement--active');
    // check and override primary
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)site-announcement\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (cookieValue) {
        $('.site-announcement--primary').addClass('dismissed');
        body.removeClass('site-announcement--active');
    }
})(jQuery);
